import { render } from "./footer_component.vue?vue&type=template&id=3caeec87&scoped=true"
import script from "./footer_component.vue?vue&type=script&lang=js"
export * from "./footer_component.vue?vue&type=script&lang=js"

import "./footer_component.vue?vue&type=style&index=0&id=3caeec87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3caeec87"]])

export default __exports__